const ecoOptions = [
    {
        value: 'https://agridential.vn/',
        name: 'Agridential',
        iconUrl:
            'https://res.cloudinary.com/agridential/image/upload/v1600757777/Logo/agdnew_ctihrd-removebg-preview_km4ppl.png'
    },
    {
        value: 'https://covidpass.vn/',
        name: 'Covid Pass',
        iconUrl:
            'https://res.cloudinary.com/agridential/image/upload/v1617072333/AGDImage/logo_covid_pass_1_3x_llsuvm.png'
    },
    {
        value: 'https://smartballot.io/',
        name: 'Smart Ballot',
        iconUrl:
            'https://res.cloudinary.com/agridential/image/upload/v1624008907/SmartBallot/Screen_Shot_2021-06-18_at_4.31.17_PM-removebg-preview_1_wkpjg0.png'
    }
]

module.exports = { ecoOptions }
